export const TAB = 9;
export const ENTER = 13;
export const SHIFT = 16;
export const CONTROL = 17;
export const ESCAPE = 27;
export const UP_ARROW = 38;
export const DOWN_ARROW = 40;
